module.exports = __webpack_public_path__ + "static/media/image_37.ff59af4c.png";